import {
  gmailWriteConnectOptions,
  hasGmailModifyScope,
  startGoogleOAuthRedirect,
} from "@/lib/googleAuth";
import type { Agent } from "@/types/aiToolkit";

export function agentCanUseGmailWrite(agent: Agent | null | undefined): boolean {
  if (!agent) return false;
  const hasCap = agent.capabilityModules?.includes("cap-gmail-write");
  const hasTool = agent.allowedToolIds?.includes("gmail");
  return Boolean(hasCap && hasTool);
}

/** Prompt for Gmail modify scope when trash/draft is requested. */
export async function ensureGmailWriteAccess(): Promise<boolean> {
  if (await hasGmailModifyScope()) return true;
  const opts = gmailWriteConnectOptions();
  startGoogleOAuthRedirect({
    scope: opts.scope,
    prompt: opts.prompt,
    returnTo: `${window.location.pathname}${window.location.search}`,
  });
  return false;
}
